import * as actionTypes from "./actionTypes"

const api = "a87898297a078d85fecce7aab9d8dbde";


{/* Categorized movies */ }
export function getCategorizedMoviesSuccess(categorizedMovies){
    return{type:actionTypes.GET_CATEGORIZED_MOVIES_SUCCESS, payload:categorizedMovies}
}

export function getCategorizedMovies(genre,page){
    return function(dispatch){
        let url = `https://api.themoviedb.org/3/discover/movie?api_key=${api}&with_genres=${genre}&page=${page}`
        return fetch(url).then(response => response.json())
        .then(result => dispatch(getCategorizedMoviesSuccess(result.results)))
    }
}


{/* Similar movies */ }
export function getSimilarMoviesSuccess(similarMovies){
    return{type:actionTypes.GET_SIMILAR_MOVIES, payload:similarMovies}
}

export function getSimilarMovies(movieId){
    return function(dispatch){
        let url = `https://api.themoviedb.org/3/movie/${movieId}/similar?api_key=${api}&language=en-US&page=1`
        return fetch(url).then(response => response.json())
        .then(result => dispatch(getSimilarMoviesSuccess(result.results)))
    }
}


{/* Top movies */ }
export function getTopMoviesSuccess(topMovies){
    return{type:actionTypes.GET_TOP_MOVIES_SUCCESS, payload:topMovies}
}

export function getTopMovies(){
    return function(dispatch){
        let url = `https://api.themoviedb.org/3/trending/movie/day?api_key=a87898297a078d85fecce7aab9d8dbde`
        return fetch(url).then(response => response.json())
        .then(result => dispatch(getTopMoviesSuccess(result.results)))
    }
}


{/* Movies */ }
export function getMoviesSuccess(movies){
    return{type:actionTypes.GET_MOVIES_SUCCESS, payload:movies}
}


export function getMovies(page=1){

    return function(dispatch){
        let url;
        if(page){
            url = `https://api.themoviedb.org/3/movie/popular?api_key=${api}&language=en-US&page=${page}`
        }
        
        return fetch(url).then(response => response.json())
        .then(result => dispatch(getMoviesSuccess(result.results)))
    }

  
}

